module.exports = __webpack_public_path__ + "static/media/shape-contact-us-mobile.a281b9c1.png";